import me from "../assets/img/me.jpg";


export const About=()=> {
  
    return (
        <div className="about" id="about">
            <h1 id="about-h1">About Me</h1>
            <div className="about-group">
                {/* <img src={placeholder} alt="Image of me" id="about-img"/> */}
                <div class="polaroid">
                        <img id ="image-of-me" src={me} alt="Image of me"/>
                        <div class="about-img-text">
                        <p>Me</p>
                     </div>
                    </div>
              
                <p className="about-p">
                Technology has been fascinating to me my whole life. I have always admired how real-world problems in the world could be solved with solutions that are both creative and logical. This open platform for solving problems is what really inspired to start coding and now I could not imagine my life without it! 
                <br></br> <br></br>
                I attained a Computer Science BSc (Hons) from Queen Mary University and I am currently a Tech Trainee at futureproof. I am a highly motivated undergraduate with 1 year experience as a full stack developer . 
                <br></br> <br></br>
                Outside of work, I am very outgoing and love to do new activities that help push me out of my comfort zones. To de-stress however, I enjoy going to the gym and playing video games.

                
                <br></br> <br></br>
                I am proficient at Javascript and React alongside a wide array of languages/frameworks. I am looking forward to an opportunity where my programming knowledge and strong problem-solving skills can be fully utilized.


                 </p>
            </div>

           
                    
    </div>
    )
  
}


